import { isParseObject, Loading } from "@opendash/core";
import { Typography } from "antd";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import { Item } from "../../../js/parsegenerated";

type Props = {
  item: Item | string;
  quantity?: number;
};

export const ItemLabel = (props: Props) => {
  const [item, setItem] = useState<Item>(
    isParseObject(props.item, Item.className) ? (props.item as Item) : undefined
  );

  const quantityLabel =
    props.quantity && item
      ? `(${props.quantity} ${item.get("stockUnit")})`
      : "";

  useEffect(() => {
    if (isParseObject(item, Item.className)) {
      setItem(item as Item);
    } else {
      new Parse.Query(Item)
        .get(props.item as string)
        .then((item) => setItem(item));
    }
  }, [item]);

  return (
    <>
      {!item && <Loading message="" />}
      {item && (
        <Typography.Text>
          {item.get("name")} {quantityLabel}
        </Typography.Text>
      )}
    </>
  );
};
